import React, { useEffect, useState } from 'react';
import { Star, Clock, User, Play, Heart, ChevronRight, ShoppingBag, ShoppingCart, PersonStanding, UserRoundCheck, ClockArrowUp, ArrowBigLeftDash, ChartNoAxesGantt, LucideGlasses } from 'lucide-react';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAllBusinessTypes } from '../../../../store/actions/CreateApp/getAllBusinessTypes';
import Snackbar from '../../../../Snackbar';

/**
 * CourseCard
 * A sleek, responsive course card built with Tailwind CSS.
 * Props:
 *  - course: {
 *      id, title, subtitle, author, duration (e.g. '3h 20m'),
 *      lessons (number), rating (0-5), reviews (number),
 *      image (url), tags: string[], price (string - 'Free' or '₹199'),
 *      progress (0-100) optional
 *    }
 *  - onSendBack(courseId)
 *  - layout: 'compact' | 'regular' (optional)
 *
 * Default export is the component. This file uses Tailwind utility classes.
 */

export default function CourseCardV1({onSendBack, courseThemeCard1Object, course,  layout = 'regular' }) {
  const {
    id,
    title = 'Untitled Course',
    subtitle = '',
    author = 'Unknown',
    duration = '',
    lessons = 0,
    rating = 0,
    reviews = 0,
    image = 'https://placehold.co/600x400?text=Course+Image',
    tags = [],
    price = 'Free',
    progress = null,
  } = course || {};
   const [snackbarVisible, setSnackbarVisible] = useState(false);
                     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                  const [itemArr, setItemArr] = useState([]);
                        
                     const dispatch = useDispatch(); 

                     useEffect(()=>{
                      fireGetAllCoursesByApp();
                     },[])
  const fireGetAllCoursesByApp=()=>{
          setItemArr([])
                
        
                
         
              const apiData = dispatch(getAllBusinessTypes({}));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
                if(response?.business_types){
                   setItemArr(response?.business_types)
                }else{
                   //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
                  
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                }
       
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
                
                 
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

         
        const flattenedData = itemArr!=[]?Object.values(itemArr):'';

        
  return (

    <>   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={()=>{}} />
      )}
      <style>{`

    :root{
  --card-bg: 
  --card-border: #e6e9ee;
  --muted: #6b7280;
  --accent: #7c3aed; /* violet */
  --accent-2: #06b6d4; /* teal */
  --radius: 16px;
}

.linked-acc-card{
  display: grid;
  grid-template-columns: 1fr;min-width: 185px;
  width: 250px;height:190px;

           border-top-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.layoutCard?.borderRadius?.bottomRight?.value+"px"};
 
  box-shadow:${courseThemeCard1Object?.layoutCard?.layoutShadow?.horizontal?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.vertical?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.blur?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.spread?.value}px ${courseThemeCard1Object?.layoutCard?.layoutShadow?.shadowColor?.color} ${courseThemeCard1Object?.layoutCard?.layoutShadow?.inset?"inset":""};
        
  
}

.linked-acc-card--compact{
  grid-template-columns: 120px 1fr;
}

.linked-acc-card__media{
  position: relative;
 
}

.linked-acc-card--compact .linked-acc-card__media{
  height: auto;
}

.linked-acc-card__image{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.linked-acc-card__tags{
  position: absolute;
  left: 2px;top:2px;
  margin-top: 2px;margin-bottom:2px;
  display: flex;flex-wrap:wrap;
  gap: 5px;
}

.linked-acc-card__tag{
  background: ${courseThemeCard1Object?.tags?.buttonBG?.color};
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 9px; 
  color: ${courseThemeCard1Object?.courseTitle?.tagsColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  border:${courseThemeCard1Object?.tags?.border?.borderWidth?.value}px ${courseThemeCard1Object?.tags?.border?.borderType} ${courseThemeCard1Object?.tags?.border?.borderColor?.color};
     border-top-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.tags?.borderRadius?.bottomRight?.value+"px"};

  box-shadow: 0 2px 6px rgba(2,6,23,0.06);
}

.linked-acc-card__enroll-btn{
  position: absolute; display:flex; justify-content:space-between;
  right: 12px;
  bottom: 12px;
  background: ${courseThemeCard1Object?.showMoreBtn?.btnColor?.color};;
  border:${courseThemeCard1Object?.showMoreBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.showMoreBtn?.border?.borderType} ${courseThemeCard1Object?.showMoreBtn?.border?.borderColor?.color};
  
  padding: 8px 12px; border-top-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.showMoreBtn?.borderRadius?.bottomRight?.value+"px"};
 
  color: ${courseThemeCard1Object?.showMoreBtn?.iconColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(2,6,23,0.08);
}

.linked-acc-card__body{
  padding: 16px;
}

.linked-acc-card__title{ display:flex;align-items:left;justify-content:left;
  margin: 0;
  font-size: 22px;
  line-height: 1.15;
  color: ${courseThemeCard1Object?.courseTitle?.titleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
}

.linked-acc-card__subtitle{ display:flex;align-items:left;justify-content:left;
  margin: 6px 0 0;
  color: var(--muted);
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.subtitleFont?.family?.fontFamily};;
  font-size: 13px;
}

.linked-acc-card__meta{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.linked-acc-card__meta-left{
  display: flex;
  gap: 12px;    color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
 

}

.linked-acc-card__meta-item{
  display: flex; 
  align-items: center;font-size:11px;
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
  gap: 5px;
}

.linked-acc-card__rating{
  font-weight: 600; display:flex; justify-content:center;align-items:center;gap:5px;
   color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-size: 13px;  
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.linked-acc-card__progress{
  margin-top: 12px;
}

.linked-acc-card__progress-row{
  display:flex;
  justify-content: space-between;
  font-size: 12px; 
  font-family:${courseThemeCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
}

.linked-acc-card__progress-bar{
  height: 8px;
  background: #eef2ff;
  border-radius: 999px;
  overflow: hidden;
  margin-top: 6px;
}

.linked-acc-card__progress-fill{
  height: 100%;
  background: ${courseThemeCard1Object?.cardTheme?.cardThemeBG?.color};;
}

.linked-acc-card__footer{
  margin-top: 14px;position:relative;
  display:flex;
  justify-content: space-between;
  align-items: center;
}

.linked-acc-card__price{
  font-weight: 700;min-width:60px;
     color: ${courseThemeCard1Object?.courseTitle?.metaColor?.color};
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.linked-acc-card__lessons{
  font-size: 11px;
  
  color: ${courseThemeCard1Object?.courseTitle?.subtitleColor?.color};
   font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;

}

.linked-acc-card__cta{
  background: ${courseThemeCard1Object?.buyNowBtn?.btnBG?.color};
  color: ${courseThemeCard1Object?.buyNowBtn?.btnColor?.color};
    
  font-family:${courseThemeCard1Object?.courseTitle?.metaFont?.family?.fontFamily};;
 
  border:${courseThemeCard1Object?.buyNowBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.buyNowBtn?.border?.borderType} ${courseThemeCard1Object?.buyNowBtn?.border?.borderColor?.color};
  
  ;font-size:12px;
  padding: 10px 10px;width:80px;
    border-top-left-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.buyNowBtn?.borderRadius?.bottomRight?.value+"px"};
 
  font-weight: 700;
  cursor: pointer;
}

.linked-acc-card__wishlist,.linked-acc-card__cart{background: rgba(144, 202, 249,0.41);
  color: white;
  border:${courseThemeCard1Object?.wishListCartBtn?.border?.borderWidth?.value}px ${courseThemeCard1Object?.wishListCartBtn?.border?.borderType} rgba(144, 202, 249,1);
  
  
           border-top-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${courseThemeCard1Object?.wishListCartBtn?.borderRadius?.bottomRight?.value+"px"};
 padding:5px;width:90px;height:40px;
 display:flex;justify-content:center;align-items:center;
  font-weight: 700;
  cursor: pointer;}
/* Responsive tweaks */
@media (max-width: 520px){
  .linked-acc-card{ width: 185px; }
  .linked-acc-card__title{ font-size: 14px; }
  .linked-acc-card__footer{justify-content:center;}
}
  
.ty-root{position:absolute;z-index:999999;top:0px;left:0px;right:0px;bottom:0px;;}
        .ty-root{ 
           
          color:#333;
          padding:0px;
        }.ty-root-inn{
         
          font-family: Arial, sans-serif;
         
          color:#333;
          padding:20px;
        }
        .ty-card{  position:relative;
             flex-direction:row;
          width:100%;display:flex;flex-wrap:wrap; gap:20px;justify-content:center;
          border-radius:8px;
          padding:0px;
          text-align:center;
        }
        .ty-icon{
          width:70px;height:70px; margin:0 auto 20px auto; border-radius:50%;
          background:#d1fae5; display:flex;align-items:center;justify-content:center;
        }
        .ty-check{
          width:30px;height:15px; border-left:4px solid #10b981; border-bottom:4px solid #10b981;
          transform:rotate(-45deg);margin-top:-14px;
        }
        .ty-title{font-size:22px;margin:0 0 10px 0;color:#111}
        .ty-sub{margin:0 0 20px 0;font-size:15px;color:#555}
        .ty-actions{display:flex;gap:12px;justify-content:center}
        .btn{
          padding:10px 18px; border:none; border-radius:6px; font-weight:600; cursor:pointer;
        }
        .btn-primary{background:#3b82f6;color:#fff}
        .btn-ghost{position:absolute;right:10px;top:10px;color:#fff;cursor:pointer;
        background:#222222;;width:30px;height:30px;border-radius:50%;display:flex;justify-content:center;align-items:center;}
     .cardLinkedAccOuter{border:3px solid  #ffffff;}

    .cardLinkedAccOuter:hover{ border:3px solid  rgba(144, 202, 249,1);}
    .cardLinkedAccOuter:hover .linked-acc-card__subtitle{ color: rgba(144, 202, 249,1);
    }
     .cardLinkedAccOuter:hover .linked-acc-card__cart,  .cardLinkedAccOuter:hover .CircleForTitleRPACC{
     animation: zoom_btn_lacc .8s 1 linear;  background:#ffffff !important;}
    .cardLinkedAccOuter {   background:rgba(144, 202, 249,0.1);;;}
   .cardLinkedAccOuter:hover {   background:#ffffff;;;}
   .cardLinkedAccOuter:hover .CircleForTitleRPACC{background:rgba(54, 125, 183, 1) !important;}
    .CircleForTitleRPACC{width:10px;height:10px;border-radius:50%;background:rgba(144, 202, 249,1);margin-right:20px;;margin-left:20px;position:relative;margin-top:5px;}
   .CircleForTitleRPACCOut{width:17px;height:17px;border-radius:50%;background:rgba(253, 253, 253, 0.51);position:absolute;top:4px;left:4px}
   .CircleForTitleRPACCOutTwo{width:25px;height:25px;border-radius:50%;background:rgba(144, 202, 249, 0.21);position:absolute;top:-7.5px;left:-7.5px}
   
@keyframes zoom_btn_lacc{
    0% {
        /* opacity: 0; */
        transform: scale(1)
    }
    50% {
        transform: scale(0.81)
    }
   
    100% {
        transform: scale(1)
    }
    }
   
   
   `}</style>


       <div >
        <header style={{display:"flex",justifyContent:"center" ,margin:"15px"}}>
          
          <div className='CircleForTitleRPACC'> <div className='CircleForTitleRPACCOutTwo'><div className='CircleForTitleRPACCOut'></div></div></div>
          <div>

<h3 id={`course-${id}-title`} className="linked-acc-card__title">Select Your Business Type</h3>

</div>
</header> <div className="ty-root-inn">
       
      <div className="ty-card ">
        
{flattenedData?flattenedData?.map((item, index) => 
        (
  <article index={index} key={item?.ID}  className={`linked-acc-card cardLinkedAccOuter ${courseThemeCard1Object?.compact?.status ? 'linked-acc-card--compact' : ''}`} aria-labelledby={`course-${id}-title`}>
<div className="linked-acc-card__media">


         

</div>


<div className="linked-acc-card__body ">

<header>
<h3 id={`course-${id}-title`} className="linked-acc-card__title">
    <div className='CircleForTitleRPACC'> <div className='CircleForTitleRPACCOutTwo'><div className='CircleForTitleRPACCOut'></div></div></div>
        
  
  {item?.display_name}</h3>
{<p className="linked-acc-card__subtitle"> <ChartNoAxesGantt size={19} color={"#222222"} /> <span>{item?.description}</span> </p>}

</header>



<footer className="linked-acc-card__footer">
<div>
</div>


<div style={{display:"flex",justifyContent:"space-between",gap:"7px"}}>
  <span className="" style={{marginTop:"10px",fontSize:"12px"}}>  {item?.pan_required||item?.gst_required?"* required:":""} <span>{item?.pan_required?"PAN ":""} {item?.gst_required?item?.pan_required?", GST":"GST":" "}</span> </span>

<button className="linked-acc-card__cart" onClick={() => onSendBack(item)}><ArrowBigLeftDash size={26} color={"#444444"} />
<span style={{color:"#444444"}}>Select </span>
</button>
</div>
</footer>
</div>
</article>)):""}</div></div></div>

    </>
  );
}

/*
Example usage:

import CourseCard from './CourseCard';

const sample = {
  id: 'c1',
  title: 'Build Modern Web Apps with React',
  subtitle: 'A hands-on project-based course',
  author: 'Kaushal Gedam',
  duration: '3h 20m',
  lessons: 24,
  rating: 4.6,
  reviews: 124,
  image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c',
  tags: ['React', 'Frontend'],
  price: '₹199',
  progress: 42,
};

<CourseCard course={sample} onSendBack={(id) => console.log('Enroll', id)} />
*/
